export default __webpack_public_path__ + "static/media/gmts-kun_icon_moji_iine_20px.46b0880d.png";